import clsx from 'clsx';
import React from 'react';
import Link from 'next/link';
import { format } from 'date-fns';

import { BaseComponentProps } from '@utils/types/baseComponents';
import ImageWithLoader from '@components/_shared/imageWithLoader';
import { BlogType } from '@utils/types/blog';
import { parseDateWithoutTimezone } from '@utils/dates';

import styles from './styles.module.scss';

type Props = BlogType & BaseComponentProps;

const BlogListItem = (props: Props) => {
  const { containerStyle, slug, image, title, excerpt, _createdAt } = props;

  return (
    <Link href={`/blog/${slug.current}`}>
      <a className={clsx([styles.blogListItem, containerStyle])}>
        <div className={styles.blogListItem__date}>
          {format(parseDateWithoutTimezone(_createdAt), `MMMM dd, yyyy`)}
        </div>

        {image && (
          <ImageWithLoader
            containerStyle={styles.blogListItem__image}
            src={image}
            alt={title}
            sizes="(max-width: 1024px) 100vw,
                       35vw"
          />
        )}

        <div className={styles.blogListItem__footer}>
          <div className={styles.blogListItem__title}>{title}</div>
          <div className={styles.blogListItem__subtitle} title={excerpt}>
            {excerpt}
          </div>
        </div>
      </a>
    </Link>
  );
};

export default BlogListItem;
